import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";
import { RepoCommitCreateInput } from "types/generated";

import { COMMIT_SPACELIFT_VCS_FILES } from "./gql";

const useCommitSpaceliftVcsFilesMutation = createDefaultMutationHook(COMMIT_SPACELIFT_VCS_FILES);

const useCommitSpaceliftVcsFiles = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [mutation, { loading }] = useCommitSpaceliftVcsFilesMutation();

  const commitFiles = useCallback(
    (input: RepoCommitCreateInput, onSuccess?: (commitId: string) => void) => {
      mutation({ input }, (data) => {
        if (data?.repoCommitCreate) {
          reportSuccess({ message: "Commit created successfully" });
          onSuccess?.(data.repoCommitCreate.id);
        }
      });
    },
    [mutation, reportSuccess]
  );

  return {
    commitFiles,
    loading,
  };
};

export default useCommitSpaceliftVcsFiles;
